(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('panel', {
                parent: 'app',
                url: '/panel',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/panel/panel.html',
                        controller: 'panelController',
                        controllerAs: 'vm',
                        resolve: {
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            });
    }
})();
